/* This JS file is the wrapper that calls the root App for React-Redux.
It is a fairly standard example of this wrapper.
We stub out the Service Worker because it was causing too much client caching
and therefore making it difficult to run new code. */

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from './Backend'
/*import registerServiceWorker from './registerServiceWorker' */
import './index.css'
import App from './App.js'

ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('cendrootdiv')
  );

/* registerServiceWorker(); */


// WEBPACK FOOTER //
// ./src/index.js